import { PROVINCE_COLORS } from "@/lib/constants";

const STATUS = ["active", "paused", "closed"];
const inputCls = "w-full rounded-md border border-slate-300 bg-white px-2.5 py-1.5 text-sm text-slate-900 outline-none focus:border-[#C8102E] focus:ring-2 focus:ring-[#C8102E]/20";

export function StreamsEditor({ streams, original, onChange }) {
  const orig = Object.fromEntries(original.map((s) => [s.id, s]));
  const update = (id, patch) => onChange(streams.map((s) => (s.id === id ? { ...s, ...patch } : s)));
  const changed = (s, k) => JSON.stringify(s[k] ?? null) !== JSON.stringify(orig[s.id]?.[k] ?? null);

  return (
    <div className="overflow-x-auto rounded-xl border border-slate-200 bg-white shadow-sm" data-testid="admin-streams-editor">
      <table className="w-full min-w-[820px] text-sm">
        <thead className="bg-slate-50 text-left text-xs font-semibold uppercase tracking-wider text-slate-500">
          <tr>
            <th className="px-4 py-3">Stream</th>
            <th className="px-4 py-3 w-32">Cutoff</th>
            <th className="px-4 py-3 w-36">Status</th>
            <th className="px-4 py-3">Status note</th>
            <th className="px-4 py-3 w-44">Rules last verified</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-100">
          {streams.map((s) => (
            <tr key={s.id} data-testid={`admin-stream-row-${s.id}`}>
              <td className="px-4 py-3">
                <div className="flex items-center gap-2">
                  <span className="inline-flex items-center rounded px-1.5 py-0.5 text-xs font-bold text-white" style={{ backgroundColor: PROVINCE_COLORS[s.province] }}>{s.province}</span>
                  <div>
                    <p className="font-semibold text-slate-900">{s.name}</p>
                    <p className="text-xs text-slate-500">{s.stream_group} · {s.scoring_model === "grid" ? `points grid (${s.grid})` : s.scoring_model.replace("_", " ")}</p>
                  </div>
                </div>
              </td>
              <td className="px-4 py-3">
                {s.scoring_model === "eligibility" ? (
                  <span className="text-xs text-slate-400">n/a</span>
                ) : (
                  <input type="number" min={0} value={s.cutoff ?? ""} data-testid={`admin-cutoff-${s.id}`}
                    onChange={(e) => update(s.id, { cutoff: e.target.value === "" ? null : Number(e.target.value) })}
                    className={`${inputCls} ${changed(s, "cutoff") ? "border-amber-400 bg-amber-50" : ""}`} />
                )}
              </td>
              <td className="px-4 py-3">
                <select value={s.status} data-testid={`admin-status-${s.id}`} onChange={(e) => update(s.id, { status: e.target.value })}
                  className={`${inputCls} ${changed(s, "status") ? "border-amber-400 bg-amber-50" : ""}`}>
                  {STATUS.map((v) => <option key={v} value={v}>{v}</option>)}
                </select>
              </td>
              <td className="px-4 py-3">
                <input type="text" value={s.status_note || ""} data-testid={`admin-note-${s.id}`} onChange={(e) => update(s.id, { status_note: e.target.value })}
                  className={`${inputCls} ${changed(s, "status_note") ? "border-amber-400 bg-amber-50" : ""}`} />
              </td>
              <td className="px-4 py-3">
                <input type="date" value={s.last_verified || ""} data-testid={`admin-verified-${s.id}`} onChange={(e) => update(s.id, { last_verified: e.target.value || null })}
                  className={`${inputCls} ${changed(s, "last_verified") ? "border-amber-400 bg-amber-50" : ""}`} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
